import type { StatusPedido } from "interfaces/loja";

/** Texto principal do card «Situação operacional» (guia ao operador). */
export function mensagemSituacaoOperacional(status: StatusPedido | string): string {
  const s = String(status ?? "").toUpperCase();
  switch (s) {
    case "AGUARDANDO_PAGAMENTO":
      return "Aguardando pagamento. Nenhuma ação operacional disponível.";
    case "PAGO":
      return "Pedido pago. Pode ser cancelado ou seguir para faturamento.";
    case "EM_PROCESSAMENTO":
    case "PROCESSANDO":
      return "Pedido em processamento. Cancelamento ainda permitido.";
    case "ENVIADO":
      return "Pedido enviado. Não pode ser cancelado. Use devolução.";
    case "ENTREGUE":
      return "Pedido entregue. Apenas devolução permitida.";
    case "DEVOLUCAO_SOLICITADA":
      return "Devolução solicitada. Aguardando confirmação.";
    case "DEVOLVIDO":
      return "Pedido devolvido e finalizado.";
    case "CANCELADO":
      return "Pedido cancelado.";
    default:
      return "Situação do pedido fora do fluxo padrão — revise os dados e o histórico.";
  }
}
